"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var WifiGoodSignal = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_WifiGoodSignal_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 12,
    height: 9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.104 8.703a6.929 6.929 0 0 1 9.792 0 .5.5 0 0 0 .708-.706 7.93 7.93 0 0 0-11.208 0 .499.499 0 1 0 .708.706Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9.855c-.993 0-1.945.394-2.646 1.095a.5.5 0 0 1-.708-.706 4.746 4.746 0 0 1 6.708 0 .5.5 0 1 1-.708.706A3.745 3.745 0 0 0 8 9.855ZM8 12.004c-.423 0-.828.168-1.126.466a.53.53 0 0 0 0 .749l.54.539a.829.829 0 0 0 1.17 0l.54-.54a.53.53 0 0 0 0-.748A1.592 1.592 0 0 0 8 12.004Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_WifiGoodSignal_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = WifiGoodSignal;
exports["default"] = _default;